export enum ButtonStateEnum {
  enabled = '',
  disabled = 'opacity-50 cursor-disabled',
}
